import React, { useState } from 'react';
import { FaComments, FaTimes, FaUser, FaEnvelope, FaPaperPlane, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import './ChatContactIcon.css';

const ChatContactIcon = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Replace this URL with your actual Google Apps Script deployment URL
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxIoXUSVpNrNM5BPwD-eisGRhRfRvCSK5fCyNaDy9k8Kcz8ZcNHuS1WBQivRvvB60Hp/exec';

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', // Required for Google Apps Script
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });

      // Since we're using no-cors, we can't read the response
      // We'll assume success if no error is thrown
      setSubmitStatus('success');
      
      // Reset form
      setFormData({ name: '', email: '', message: '' });
      
      // Close form after a delay to show success message
      setTimeout(() => {
        setShowForm(false);
        setSubmitStatus(null);
      }, 2000);

    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({ name: '', email: '', message: '' });
    setSubmitStatus(null);
    setShowForm(false);
  };

  return (
    <>
      <div 
        className="chat-contact-icon"
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
        onClick={() => setShowForm(true)}
      >
        <FaComments className="chat-icon" />
      </div>

      {/* Hover Popup */}
      {showPopup && !showForm && (
        <div 
          className="chat-popup"
          onMouseEnter={() => setShowPopup(true)}
          onMouseLeave={() => setShowPopup(false)}
          onClick={() => setShowForm(true)}
        >
          <div className="popup-header">
            <div className="popup-avatars">
              <div className="avatar avatar-1"></div>
              <div className="avatar avatar-2"></div>
            </div>
            <div className="popup-title">
              <h4>How can we help you?</h4>
              <p>Please send us a message</p>
            </div>
          </div>
          <div className="popup-content">
            <p>You are in the right place if you need any help. Please send us a message and we will get back to you. Thank you.</p>
            <button className="popup-button" onClick={(e) => {
              e.stopPropagation();
              setShowForm(true);
            }}>
              Send us a message
            </button>
          </div>
        </div>
      )}

      {/* Contact Form Modal */}
      {showForm && (
        <div className="form-modal-overlay" onClick={resetForm}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="chat-form-header">
              <div className="form-avatars">
                <div className="avatar avatar-1"></div>
                <div className="avatar avatar-2"></div>
              </div>
              <div className="form-title">
                <h4>How can we help you?</h4>
                <p>Please send us a message</p>
              </div>
              <button className="close-button" onClick={resetForm}>
                <FaTimes />
              </button>
            </div>
            
            {/* Success/Error Messages */}
            {submitStatus === 'success' && (
              <div className="submit-message success">
                <FaCheckCircle />
                <p>Data submitted successfully! We'll get back to you soon.</p>
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="submit-message error">
                <FaExclamationCircle />
                <p>Sorry, there was an error sending your message. Please try again.</p>
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <div className="input-wrapper">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="email">E-mail:</label>
                <div className="input-wrapper">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter email address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message:</label>
                <div className="input-wrapper">
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Type a message..."
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="4"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <div className="loading-spinner"></div>
                    Sending...
                  </>
                ) : (
                  <>
                    <FaPaperPlane /> Send us a message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatContactIcon; 